module.exports = __webpack_public_path__ + "static/img/home_c_7.22affc48.png";